// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../../hola/pub/settings_ctx';
import cn from 'classnames';
import styles from './full_page_slider.module.less';
import {use_qs_with_set} from '../../../hola/pub/lib/use_qs';

interface i_pricing_slider_props {
    type_param: string;
    period_param?: string;
    def_type?: 'shared_dc'|'dedicated_dc'|'isp'|'smart_resi'|'isp_plus';
    items: {
        id: string,
        [key: string]: string | JSX.Element
    }[];
}

export const Full_page_slider = (props:i_pricing_slider_props)=>{
  const {theme} = useContext(Settings_context);
  const {type_param, items, def_type} = props;
  const {qs} = use_qs_with_set();
  const active = qs[type_param] || def_type || items[0].id;
  return <div style={{'--count_slides': props.items.length} as any}
    className={styles.pricing_slider_container}>
      <div className={styles.moving_div}>
        {items.map(item=>{
          return <div className={cn(styles.container_wrapper,
            active == item.id && styles.active_wrapper)} key={item.id}>
            <div className={cn(styles.items_container,
              theme.container)}>
              {item.content}
             </div>
          </div>;
        })}
    </div>
  </div>;
};
